import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-legal-notice',
  templateUrl: './legal-notice.component.html',
  styleUrls: ['./legal-notice.component.less']
})
export class LegalNoticeComponent implements OnInit {


  complaintEmail = '';
  faisEmail = '';
  ncrEmail = '';
  constructor() { }

  ngOnInit(): void {
    this.ncrEmail = "complaints@ncr.org.za";
    this.complaintEmail = 'Complaints@bmwfinance.co.za';
    this.faisEmail = 'info@faisombud.co.za';
  }

}
